/**
 * @summary Проверка, является ли значение объектом.
 * Используется в toSnakeCaseFormat и в toCamelCaseFormat.
 */
const isObject = (value: any) => {
  return value && typeof value === 'object' && !Array.isArray(value);
};

/**
 * @summary Преобразует строку в snake_case формат.
 */
export const toSnakeCase = (text: string) => text.replace(/([A-Z])/g, '_$1').toLowerCase();

/**
 * @summary Преобразует ключи объекта в snake_case формат (рекурсивно).
 *
 * @param data - Объект, ключи которого надо трансформировать в формат snake_case.
 */
export function toSnakeCaseFormat(data: any): any {
  if (Array.isArray(data)) {
    return data.map((item) => toSnakeCaseFormat(item));
  }

  if (isObject(data)) {
    return Object.fromEntries(
      Object.entries(data).map(([key, value]) => [toSnakeCase(key), toSnakeCaseFormat(value)])
    );
  }

  return data;
}

/**
 * @summary Преобразует ключи объекта в camelCase формат (рекурсивно).
 *
 * @param data - Объект, ключи которого надо трансформировать в формат camelCase.
 */
export function toCamelCaseFormat(data: any): any {
  const replacer = ([, symbol]: any) => symbol.toUpperCase();
  const toCamelCase = (text: string) => text.replace(/(_[a-z])/g, replacer);

  if (Array.isArray(data)) {
    return data.map((item) => toCamelCaseFormat(item));
  }

  if (isObject(data)) {
    return Object.fromEntries(
      Object.entries(data).map(([key, value]) => [toCamelCase(key), toCamelCaseFormat(value)])
    );
  }

  return data;
}

/**
 * @summary Функция для нормализации номера телефона или его части.
 * Убирает из строки все символы, кроме цифр.
 * Добавляет "+" в начало, если он отсутствует и строка не пустая.
 */
export const formatPhoneNumber = (value: string) => {
  if (value === '') {
    return value;
  }

  const formattedValue = value.replace(/^(\+)|\D/g, '$1');

  if (formattedValue.startsWith('+')) {
    return formattedValue;
  }

  return `+${formattedValue}`;
};
